var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('v-container',[_c('simple-header',{attrs:{"profile":_vm.profile}}),_c('board-stepper',{ref:"boardstepper"}),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }